export default __webpack_public_path__ + "static/policy2-80271e31dff71557aa24dac0acf79f93.png";